import { createDivIn, createImgIn, setElementInnerHTML } from '../../ui_utils/DomUtils.ts';
import { LobbyImage } from '@colonist/types';
import { RoomSettingConstants } from '@colonist/game-base-types';
import { createTooltipIn } from '../../ui_utils/TooltipUtils.ts';
export class UILobbyTableRowNoTrollsController {
    update(minimumKarma, oldRoomData) {
        if (!UILobbyTableRowNoTrollsController.changedNoTrollsData(minimumKarma, oldRoomData)) return;
        this.removeNoTrollsIcon();
        if (UILobbyTableRowNoTrollsController.isNoTrollsRoom(minimumKarma)) this.addNoTrollsIcon();
    }
    removeNoTrollsIcon() {
        setElementInnerHTML(this.noTrollsIcon, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
    }
    addNoTrollsIcon() {
        const karmaImage = createImgIn(this.noTrollsIcon, LobbyImage.IconNoTroll);
        createTooltipIn(karmaImage, {
            key: 'strings:roomPage.options.noTrollsGame.title'
        });
    }
    static changedNoTrollsData(minimumKarma, oldRoomData) {
        if (oldRoomData == undefined) return true;
        if (oldRoomData.minimumKarma != minimumKarma) return true;
        return false;
    }
    static isNoTrollsRoom(minimumKarma) {
        return minimumKarma == RoomSettingConstants.NO_TROLLS_KARMA_THRESHOLD;
    }
    constructor(container, roomData){
        this.noTrollsIcon = createDivIn(container, 'no_trolls_icon');
        this.update(roomData.minimumKarma);
    }
}
